<template>
  <div class="flex_column_evenly device_info">
    <div class="flex_row_center">
      <i class="incfont el-icon-title"></i>
      <span lang="DongleRGBTitle" class="margin_left">设备信息</span>
    </div>
    <div class="flex_row device_info" style="width: 60vw;">
      <div class="flex_column_evenly">
        <el-radio 
        v-for="(item,index) in language.DongleRGBOptions"
        :key="index"
        v-removeAriaHidden 
        v-model="dongleRGBMode" 
        :label="item.value" 
        class="flex_row_center"
        style="white-space: normal;"> 
        <span>{{item.option}}</span></el-radio>
      </div>
    </div>
  
  </div> 
</template>

<script>
import HIDHandle from '@/assets/js/HIDHandle';

  export default {
    data() {
      return {
        language:{},
        dongleRGBMode:1
      }
    },
    methods: {

    },
    watch: {
      "dongleRGBMode":{
        async handler() {
          await HIDHandle.Set_Device_4KDongleRGBMode(this.dongleRGBMode);
        }
      }
    },
    created() {
      this.$bus.$on("setMouseDefaultCfg",deviceCfg => {
        if(typeof deviceCfg.dongle4KRGB != "undefined") {
          this.dongleRGBMode = deviceCfg.dongle4KRGB.mode;
        }
      }); 

      this.$bus.$on("updateDeviceInfo",value => {
        this.dongleRGBMode = value.dongle4KRGB.mode;
      });

      this.$bus.$on("languageChange",lang => {     
        if(typeof lang != 'undefined') {
          this.language = lang;
        }
      });
    },
    beforeDestroy() {
      this.$bus.$off("updateDeviceInfo");
      this.$bus.$off("setMouseDefaultCfg");
      this.$bus.$off("themeChange");
      this.$bus.$off("languageChange");
    }
  }
</script>

<style lang="less" scoped>
  
</style>